// Angular
import { Injectable, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { Observable, of } from 'rxjs';

// Models
import { AppCleanup, AppSettings } from '../models';

@Injectable()
export class AppSettingsService extends AppCleanup implements OnInit, OnDestroy {
	ngOnInit() {}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	getSettings(): Observable<AppSettings> {
		let settings = new AppSettings();
		return of<AppSettings>(settings);
	}
}
